import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

interface ExploreAppsCardProps {
  exploreRoute: string;
}

export const ExploreAppsCard = ({ exploreRoute }: ExploreAppsCardProps) => {
  const navigate = useNavigate();
  const handleExploreApps = () => {
    if (exploreRoute) navigate(exploreRoute);
  };

  return (
    <Box className="explore-apps-card">
      {/* Background Video */}
      <img
        src="/images/InspireLibrary/exploreLibraryBg.gif"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />
      <Box className="bg-overlay" />
      {/* Content */}
      <Box
        className="explore-apps-card-content"
        sx={{ position: "relative", zIndex: 1 }}
      >
        <Box className="content-text">
          <p className="content-text-title">Get inspired</p>
          <p className="content-text-desc">
            Let creativity guide your next move.
          </p>
        </Box>
        <Box className="explore-apps-action" onClick={handleExploreApps}>
          Explore apps
        </Box>
      </Box>
    </Box>
  );
};
